export const SyncAlert: React.FC<{ lastUpdated: Date | null | undefined }> = ({ lastUpdated }) => {
  const showAlert = !lastUpdated || lastUpdated.getTime() < Date.now() - 1000 * 60 * 60 * 24; // 24 hours
  return showAlert ? <span className="align-text-bottom text-warning">⚠</span> : null;
};
